import styled from 'styled-components';
import { animated } from 'react-spring';
import { FADE, t } from 'theme';

const Table = styled.div`
  position: relative;
  border: 1px solid ${t('tableBorder')};
  transition: border-color ${FADE};
  width: 150px;
  padding: 5px 10px;
  font-family: monospace;
`;

const TableSummaryValues = styled(animated.span)`
  font-weight: bold;
  margin-left: 5px;
`;

// The label straddles the table's top border, so its background has to match whatever it sits
// on — the page, unless a caller pins it to something else (CityStatus, over the town image).
//
// It had no transition, which meant it jumped to the new palette on the first frame of dusk
// and then sat there as a solid black bar on a page that was still white, for as long as the
// page took to catch up. It was the most visible artefact of the whole crossover.
const TableSummary = styled.div`
  background-color: ${props => props.backgroundColor || t('bg')(props)};
  transition: background-color ${FADE};
  position: absolute;
  top: -7px;
  right: 10px;
  font-size: smaller;
  padding: 0 2px;
  display: flex;
  align-items: center;
`;
export { Table, TableSummary, TableSummaryValues };
